import React from "react";
import connect from "stores/connect";
import { Spinner } from "components/common";
import CorrelationSummary from "./CorrelationSummary";
import EventsLicenseStatus from "./EventsLicenseStatus";
import { EventsLicenseStore, EventsLicenseActions } from "./EventsLicenseStore";
class CorrelationSummaryContainer extends React.Component {
  componentDidMount() {
    EventsLicenseActions.getLicenseStatus();
  }
  render() {
    const { eventsLicenseStatus, ...otherProps } = this.props;
    if (eventsLicenseStatus.loading) {
      return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event Correlation information..." });
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EventsLicenseStatus, { licenseStatus: eventsLicenseStatus }), /* @__PURE__ */ React.createElement(CorrelationSummary, { ...otherProps }));
  }
}
export default connect(CorrelationSummaryContainer, {
  eventsLicenseStatus: EventsLicenseStore
});
